define('collections/manual_payment_transactions',['require','backbone'],function(require){

    var Backbone = require('backbone');

    return Backbone.Collection.extend({
        url: 'manual-payment-transactions',

        initialize: function (models) {
            this.set(models);
            this.total = models.length;
        }
    });

});
